import cx from 'classnames';
import OrganizationPicker from "../../core/components/OrganizationPicker/OrganizationPicker";
import { Button, Modal } from 'llui';
import { useState } from 'react';
import "./OrganizationMoveToModal.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function OrganizationMoveToModal({
  boxClassName,
  onClose,
  onMove,
  optionFilter,
  org,
  ...rest
}) {
  const [value, setValue] = useState(org.parent && org.parent.id);
  const handleCancel = () => onClose && onClose();
  const handleMove = () => {
    if (onClose) onClose();
    if (onMove) onMove(value);
  };
  return /*#__PURE__*/_jsxs(Modal, {
    boxClassName: cx('OrganizationMoveToModal__box', boxClassName),
    ...rest,
    "data-sentry-element": "Modal",
    "data-sentry-component": "OrganizationMoveToModal",
    "data-sentry-source-file": "OrganizationMoveToModal.tsx",
    children: [/*#__PURE__*/_jsx(OrganizationPicker, {
      allowCreate: false,
      label: `Move "${org.name}" to`,
      onChange: setValue,
      optionFilter: optionFilter,
      value: value,
      "data-sentry-element": "OrganizationPicker",
      "data-sentry-source-file": "OrganizationMoveToModal.tsx",
      "data-sentry-element": "OrganizationPicker"
    }), /*#__PURE__*/_jsxs("div", {
      className: "OrganizationMoveToModal__actions",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: handleCancel,
        variant: "secondary",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "OrganizationMoveToModal.tsx",
        "data-sentry-element": "Button",
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        onClick: handleMove,
        variant: "primary",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "OrganizationMoveToModal.tsx",
        "data-sentry-element": "Button",
        children: "Move"
      })]
    })]
  });
}